<template>
<div class="tp-root" :style="themePageStyle">
  <nav class="tp-topbar">
    <div class="container d-flex align-items-center py-2">
      <a href="javascript:void(0)" @click="$router.go(-1)" class="tp-back"><i class="mdi mdi-arrow-left"></i></a>
      <img src="assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" class="me-3" />
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:14px;">Terms &amp; Privacy</span>
      <span v-if="version" class="tp-version">v{{ version }}</span>
    </div>
  </nav>

  <div class="container tp-container">
    <div class="tp-card">
      <terms-content />
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import TermsContent from "@/components/flockr-legal/TermsContent.vue";
import { executeJson, flocker } from "@/api";
export default {
  name: "TermsPage",
  components: { TermsContent },
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,
    version:''
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'}
  },
  mounted(){
    var self=this;
    this.themeObserver=new MutationObserver(function(){self.darkMode=document.documentElement.getAttribute('data-theme')!=='light'});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    this.fetchVersion();
  },
  beforeUnmount(){if(this.themeObserver)this.themeObserver.disconnect()},
  methods:{
    async fetchVersion(){
      try{
        var r=await executeJson({function:'getTermsStatus',userId:sessionStorage.getItem('userId')||''},flocker);
        if(r.data&&r.data.success&&r.data.data) this.version = r.data.data.currentVersion || '';
      }catch(e){}
    }
  }
};
</script>

<style scoped>
.tp-root{min-height:100vh}
.tp-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.tp-back{color:var(--fm-m,#A09888);font-size:22px;margin-right:12px;text-decoration:none}
.tp-version{margin-left:auto;color:var(--fm-s,#6B6356);font-size:12px}
.tp-container{padding-top:24px;padding-bottom:60px;max-width:920px}
.tp-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:14px;padding:32px;color:var(--fm-h,#F5F0E8);line-height:1.7}
html[data-theme="light"] .tp-topbar{background:rgba(247,245,242,.96);border-bottom-color:#E8E2DA}
html[data-theme="light"] .tp-card{background:#FFFFFF;border-color:#E8E2DA;color:#1A1A1A}
</style>
